import { Tooltip as TooltipContainer } from 'react-tooltip';
import clsx from 'clsx';

export const Tooltip = ({ anchor, positionStrategy, isOpen, className = '', place = 'top', children, id, style = {} }) => {
  return (
    <TooltipContainer
      id={id}
      anchorSelect={anchor}
      place={place}
      positionStrategy={positionStrategy}
      className={clsx('w-100 border-radius-12 p-12px', className)}
      style={{ backgroundColor: '#eaeefe', ...style }}
      opacity={1}
      isOpen={isOpen}
    >
      {children}
    </TooltipContainer>
  );
};